// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export const DEFAULT_PARTITION_KEY_PATH = "/_partitionKey" as "/_partitionKey"; // eslint-disable-line @typescript-eslint/prefer-as-const
